import Axios from './Axios';
import { v4 as uuidv4 } from 'uuid';


export async function view(file) {
  let result = false;
  const requestOptions = {
    url: 'files/view',
    params: {
      path: file
    }
  };
  const filePromises = new Promise(async (resolve, reject) => {
    
    const response = await Axios(requestOptions);
      if(response) {
        if (response.data.status && response.data.status !== 1000) {
          resolve('')
        } else {
          const decryptedData = response.data; // داده رمزگشایی‌شده
          const bufferArray = decryptedData.data;
          const uint8Array = new Uint8Array(bufferArray);
          const blob = new Blob([uint8Array], {
            type: 'image/jpeg'
          });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = async () => {
            try {
              resolve(reader.result);
            } catch (err) {
              reject(err);
            }
          };
          reader.onerror = error => {
            reject(error);
          };
        }
      }
      else {
        resolve('')
      }
      
    
    
  });
  result = await Promise.race([filePromises]);
  result = result.replace('data:application/json', 'data:image/jpeg');
  return result;
}
export async function getFile(file, hasTemp) {
  const chunks = [];
  let totalCunks = 0;
  let uuid = uuidv4()
  let currentChunk = -1
  
  while (true) {
    const requestOptions = {
      url: 'files/download',
      params: {
        filePath: file,
        reqId: uuid,
        currentChunk: currentChunk,
        hasTemp: hasTemp
      }
    };

    try {
      const response = await Axios(requestOptions);
      totalCunks = response.data.data.totalChunks

      if(response.data.data.chunk) {
        
        chunks.push(response.data.data.chunk);
        
      }
      
      currentChunk++
    

      if (currentChunk >= totalCunks) {
        break
      }
      
      

    } catch (error) {
      console.error('Error downloading chunk:', error);
      return false;
    }
  }

  const base64ToUint8Array = (base64) => {
    const binaryString = atob(base64); // تبدیل Base64 به رشته باینری
    const length = binaryString.length;
    const uint8Array = new Uint8Array(length);

    for (let i = 0; i < length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i); // تبدیل هر کاراکتر به کد ASCII
    }

    return uint8Array;
  }

  const allChunks = chunks.map(chunk => base64ToUint8Array(chunk));

  // محاسبه طول کل برای آرایه جدید
  const totalLength = allChunks.reduce((acc, chunk) => acc + chunk.length, 0);

  // ایجاد یک Uint8Array جدید برای ترکیب همه چانک‌ها
  const combinedArray = new Uint8Array(totalLength);

  // پر کردن Uint8Array جدید با داده‌ها
  let offset = 0;
  allChunks.forEach(chunk => {
    combinedArray.set(chunk, offset);
    offset += chunk.length;
  });

    // ترکیب چانک‌ها به یک بافر نهایی
    return combinedArray;
}
